export default __webpack_public_path__ + "static/media/Pretendard-Black.14a71ec5.woff2";